import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import { sendAnalyticsEvent } from '../../utils/analytics';

class MostPopularLink extends PureComponent {
  handleClick = () => {
    sendAnalyticsEvent(
      'Most Popular',
      'Click',
      this.props.url
    );
  };

  render = () => (
    <div className="most-popular-story">
      <Link to={this.props.url} onClick={this.handleClick}>
        <div
          className={`story-number index-${this.props.index}`}
          dangerouslySetInnerHTML={{ __html: `${this.props.index}` }}
        />
        <div className="story-title">
          <span dangerouslySetInnerHTML={{ __html: this.props.title }} />
        </div>
      </Link>
    </div>
  );
}

MostPopularLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
};

export default MostPopularLink;
